import { createContext, useEffect, useState } from "react";
import { useSessionStorage } from '../hooks/useSessionStorage'

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useSessionStorage('auth', {});
    const [isAuthenticated, setIsAuthenticated] = useState(user.token);
    const [firstLoginPass, setFirstLoginPass] = useState('');
    const [sessionToken, setSessionToken] = useState('');

    useEffect(() => {
        if (user.token) {
            setIsAuthenticated(true);
        }
    }, [])

    const onLogin = (user) => {
        setUser(user);
        setIsAuthenticated(true);
    }

    const onLogout = () => {
        setUser({})
        setIsAuthenticated(false);
    }

    return (
        <AuthContext.Provider value={{ user, onLogin, onLogout, isAuthenticated, setUser, firstLoginPass, setFirstLoginPass, sessionToken }}>
            {children}
        </AuthContext.Provider>
    )
}